import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormsItemModalComponent } from './forms-item-modal.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from "@angular/material/dialog";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import {ToothPickerModule} from '../../tdo-shared/tooth-picker/tooth-picker.module';
import {ToothUiManagerModule} from '../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.module';
import { ToothUiManagerService } from '../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.service';

@NgModule({
  declarations: [
    FormsItemModalComponent
  ],
    imports: [
        CommonModule,
        FormsModule,

        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatRadioModule,
        ToothPickerModule
    ],
  exports: [
    FormsItemModalComponent
  ],
  providers: [
    ToothUiManagerService
  ]
})
export class FormsItemModalModule { }
